import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { TAILWIND_TO_CSS } from "utils/constant/STYLE";
import { formatedDate } from "./PerformanceCharts";
import { useRouter } from "next/router";
import { useStrategyIso } from "./Index";

function PerformanceHighcharts({
  seriesData,
  kospiSeriesData,
  nasdaqSeriesData,
  xaxisData,
  period,
}: {
  seriesData: any;
  kospiSeriesData: any;
  nasdaqSeriesData: any;
  xaxisData: any;
  period: string;
}) {
  const router = useRouter();
  const iso = useStrategyIso();
  const omissionSereisData = seriesData.filter((point: any, index: any) => {
    if (index === 0) return true;
    if (index === seriesData.length - 1) return true;

    if (index % 7 === 0) return null;
    if (index % 5 === 0) return null;
    if (index % 3 === 0) return null;
    if (period === "3개월") return true;
    if (index % 11 === 0) return null;
    if (index % 13 === 0) return null;
    if (index % 17 === 0) return null;
    if (index % 19 === 0) return null;
    if (index % 2 === 1) {
      return true;
    } else {
      return null;
    }
  });
  const omissionKospiSeriesData = kospiSeriesData.filter(
    (point: any, index: any) => {
      if (index === 0) return true;
      if (index === kospiSeriesData.length - 1) return true;
      if (index % 7 === 0) return null;
      if (index % 5 === 0) return null;
      if (index % 3 === 0) return null;
      if (period === "3개월") return true;
      if (index % 11 === 0) return null;
      if (index % 13 === 0) return null;
      if (index % 17 === 0) return null;
      if (index % 19 === 0) return null;

      if (index % 2 === 1) {
        return true;
      } else {
        return null;
      }
    }
  );
  const omissionNasdaqSeriesData = nasdaqSeriesData.filter(
    (point: any, index: any) => {
      if (index === 0) return true;
      if (index === nasdaqSeriesData.length - 1) return true;
      if (index % 7 === 0) return null;
      if (index % 5 === 0) return null;
      if (index % 3 === 0) return null;
      if (period === "3개월") return true;
      if (index % 11 === 0) return null;
      if (index % 13 === 0) return null;
      if (index % 17 === 0) return null;
      if (index % 19 === 0) return null;

      if (index % 2 === 1) {
        return true;
      } else {
        return null;
      }
    }
  );
  const indexSeriesData =
    iso === "US" ? omissionNasdaqSeriesData : omissionKospiSeriesData;

  const omissionXaxisData = xaxisData.filter((point: any, index: any) => {
    if (index === 0) return point;
    if (index === xaxisData.length - 1) return point;
    if (index % 7 === 0) return null;
    if (index % 5 === 0) return null;
    if (index % 3 === 0) return null;
    if (period === "3개월") return true;
    if (index % 11 === 0) return null;
    if (index % 13 === 0) return null;
    if (index % 17 === 0) return null;
    if (index % 19 === 0) return null;
    if (index % 2 === 1) {
      return point;
    } else {
      return null;
    }
  });
  const options: Highcharts.Options = {
    series: [
      {
        type: "spline",
        name: "STRATEGY",
        data: [...omissionSereisData],
        marker: {
          enabled: false, // marker 제거
        },
        color:
          omissionSereisData[omissionSereisData.length - 1] > 0
            ? TAILWIND_TO_CSS["red40"]
            : TAILWIND_TO_CSS["blue40"],
        lineWidth: 2,
        zIndex: 3,
      },
      {
        type: "spline",
        name: "INDEX",
        data: [...indexSeriesData],
        marker: {
          enabled: false, // marker 제거
        },
        color: TAILWIND_TO_CSS["gray30"],
        lineWidth: 2,
        zIndex: 3,
      },
    ],
    xAxis: {
      maxPadding: 0.001,
      categories: omissionXaxisData,
      type: "linear", // x축을 순차적으로 표시
      //   visible: false,
      tickLength: 0, // x축 tick 숨기기
      lineWidth: 0, // x축 선 숨기기
      labels: {
        enabled: false,
      },
      // plotLines: [
      //   {
      //     value: 0,
      //     color: TAILWIND_TO_CSS["gray30"],
      //     width: 0,
      //     dashStyle: "Dash", // 점선 스타일
      //     label: {
      //       useHTML: true,
      //       text: `<div style="color:${
      //         TAILWIND_TO_CSS["gray40"]
      //       }; font-size: 10px; font-style: normal; font-weight: 400; line-height: 15px;" >${formatedDate(
      //         omissionXaxisData[1],
      //         router,
      //         period === "1년" || period === "전체"
      //       )}</div>`,
      //       align: "left",
      //       x: 0,
      //       y: 15,
      //       verticalAlign: "bottom", // 라벨을 아래쪽에 위치
      //       rotation: 0, // 텍스트 회전을 0도로 설정해 정방향으로 표시
      //     },
      //   },
      //   {
      //     value: omissionXaxisData.length - 1,
      //     color: TAILWIND_TO_CSS["gray30"],
      //     width: 0,
      //     dashStyle: "Dash", // 점선 스타일
      //     label: {
      //       useHTML: true,
      //       text: `<div style="color:${
      //         TAILWIND_TO_CSS["gray40"]
      //       }; font-size: 10px; font-style: normal; font-weight: 400; line-height: 15px;" >${formatedDate(
      //         omissionXaxisData[omissionXaxisData?.length - 1],
      //         router,
      //         period === "1년" || period === "전체"
      //       )}</div>`,
      //       align: "right",
      //       x: 0,
      //       y: 15,
      //       verticalAlign: "bottom", // 라벨을 아래쪽에 위치
      //       rotation: 0, // 텍스트 회전을 0도로 설정해 정방향으로 표시
      //     },
      //   },
      // ],
    },
    yAxis: {
      //   max: maxValue + 3, // 계산한 최대값을 설정
      //   min: minValue - 3, // 계산한 최소값을 설정
      startOnTick: false, // y축의 시작점을 정확한 min 값으로 설정
      endOnTick: false, // y축의 끝점을 정확한 max 값으로 설정
      gridLineWidth: 0,
      title: {
        text: "",
      },

      tickAmount: 5, // y축 눈금 개수
      opposite: true,
      labels: {
        enabled: false,
        x: 3,
        reserveSpace: true,
        useHTML: true,
        formatter: function () {
          return `<span style="color:${
            TAILWIND_TO_CSS["gray40"]
          }; font-size: 10px; font-style: normal; font-weight: 400; line-height: 10px;">${
            Number(this.value) > 0 ? "+" : ""
          }${this.value.toLocaleString("en-us")}</span>`;
        },
      },
      plotLines: [
        {
          value: 0,
          color: TAILWIND_TO_CSS["gray30"],
          width: 0.4,
          dashStyle: "Dash", // 점선 스타일
        },
      ],
    },
    chart: {
      type: "spline",
      // marginRight: 28,
      // marginTop: 10,
      // marginBottom: 20,
      // marginLeft: 0,
      // spacingRight: 30,
      spacingRight: 0,
      spacingBottom: 0,
      spacingTop: 0,
      spacingLeft: 0,
      margin: 0,
      height: 200,
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true, // 항상 마커(꼬리)를 보이게 설정
          states: {
            hover: {
              enabled: false, // Hover 시 상태 변경 비활성화
            },
          },
        },
        dataGrouping: {
          enabled: false, // 데이터 그룹화 비활성화
        },
        states: {
          inactive: {
            opacity: 1,
          },
          hover: {
            enabled: false,
          },
        },
      },
      line: {
        marker: {
          enabled: false,
        },
      },
    },
    tooltip: {
      enabled: false,
      shared: true,
      //   formatter: function () {
      //     let tooltip = `<b style="font-size:11px;">${this?.points?.[0]?.point.BASE_DT}</b><br/>`; // x축 값 표시

      //     this?.points?.forEach((point) => {
      //       tooltip += `<span style="font-size:10px; color:${
      //         point.series.color
      //       }">\u25CF</span> ${point.series.name}: <b>${Number(point.y).toFixed(
      //         1
      //       )}</b><br/>`;
      //     });

      //     return tooltip;
      //   },
    },
    title: {
      text: undefined, // 타이틀 제거
    },
    legend: {
      enabled: false,
    },
    exporting: {
      enabled: false, // 내보내기 버튼(햄버거 모양 아이콘) 비활성화
    },
    credits: {
      enabled: false,
    },
  };
  return (
    <div className="py-2">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}

export default PerformanceHighcharts;
